import { createContext } from "react";

// 初始值為 null
export const AuthContext = createContext({
    user: null,
    setUser: () => {}
  });